import React, { useEffect, useState } from "react";
import axios from "axios";
import { Loader2, Music2 } from "lucide-react";
import { API, auth, SERIF } from "../soulumoPractice/practiceApi";

// Coach / group start: choose which of your installations everyone will share.
export const InstallationPicker = ({ onPick }) => {
  const [items, setItems] = useState(null);
  const [q, setQ] = useState("");
  useEffect(() => {
    axios.get(`${API}/api/audio-journeys`, auth())
      .then((r) => setItems((r.data.items || []).filter((j) => j.audio_status === "ready" && !j.saved_from_slug)))
      .catch(() => setItems([]));
  }, []);
  if (items === null) return <Loader2 className="mt-10 animate-spin text-[#d7bb7a]" />;
  return (
    <section className="mt-10" data-testid="together-picker">
      <p className="text-[0.62rem] uppercase tracking-[0.28em] text-[#d7bb7a]">Choose the installation to share</p>
      {!items.length && <p className="mt-4 text-sm text-[#cfc6ae]" data-testid="together-picker-empty">Create an installation first, then come back to invite your group.</p>}
      {items.length > 8 && <input value={q} onChange={(e) => setQ(e.target.value)} placeholder="Search your installations" data-testid="together-picker-search"
        className="mt-4 w-full rounded-full border border-[#2b3d5e] bg-transparent px-5 py-3 text-sm text-[#f3ecd9] outline-none focus:border-[#d7bb7a]/60" />}
      <div className="mt-4 space-y-2">
        {items.filter((j) => (j.name || "").toLowerCase().includes(q.toLowerCase())).slice(0, 40).map((j) => (
          <button key={j.id} type="button" onClick={() => onPick(j.id)} data-testid={`together-pick-${j.id}`}
            className="flex w-full items-center gap-3 rounded-2xl border border-[#2b3d5e] px-4 py-3 text-left transition-colors hover:border-[#d7bb7a]/60">
            <Music2 size={16} className="shrink-0 text-[#d7bb7a]" />
            <span className="min-w-0 flex-1 truncate text-lg" style={{ fontFamily: SERIF }}>{j.name}</span>
            {j.duration_minutes && <span className="text-xs text-[#8f8a78]">{j.duration_minutes} min</span>}
          </button>
        ))}
      </div>
    </section>
  );
};
